module.exports = __webpack_public_path__ + "static/media/PDF_58.f3c91671.pdf";